import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SendIcon = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <path d="M19.8 12.925l-15.4 6.5a.99.99 0 01-.95-.087c-.3-.192-.45-.471-.45-.838v-13c0-.366.15-.646.45-.837a.99.99 0 01.95-.088l15.4 6.5c.417.184.625.492.625.925 0 .434-.208.742-.625.925zM5 17l11.85-5L5 7v3.5l6 1.5-6 1.5V17z" />
    </SvgIcon>
);
export default SendIcon;
